import { render } from "./SignInView.vue?vue&type=template&id=204587b2"
import script from "./SignInView.vue?vue&type=script&lang=js"
export * from "./SignInView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__